import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  id: string;
  body: {
    name: string;
    businessDivisionId: string;
    managerEmployeeIds: string[];
  };
};

const request = ({ id, body }: RequestDataType) => {
  return new ApiClient()
    .put<ResponseMessageType>(`/api/managers/business_sections/${id}`, {
      businessSection: body,
    })
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersBusinessSectionsUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
